import React, { useState } from 'react';
import { View, Text, ScrollView, TextInput, TouchableOpacity, RefreshControl, StyleSheet } from 'react-native';
import { Header } from '../../components/Header';
import { SlotPicker } from '../../components/SlotPicker';
import { useGetAvailableSlotsQuery } from '../../store/api';
import { useTheme } from '../../theme/ThemeContext';
import { COLORS, getThemeStyles, globalStyles } from '../../theme/designSystem';

export const AvailableSchedulesScreen = ({ navigation }: any) => {
  const todayStr = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const { data, isLoading, refetch } = useGetAvailableSlotsQuery(selectedDate);
  const { isDark } = useTheme();
  const theme = getThemeStyles(isDark);

  return (
    <View style={[globalStyles.container, { backgroundColor: theme.bg }]}>
      <Header title="Master Schedules" subtitle="View Available slots per Master Admin work schedule" />

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingHorizontal: 20, paddingBottom: 24 }}
        refreshControl={<RefreshControl refreshing={isLoading} onRefresh={refetch} />}
      >
        {/* Date Selector */}
        <View style={[globalStyles.card, { backgroundColor: theme.cardBg, borderColor: theme.border, marginBottom: 20 }]}>
          <Text style={[styles.label, { color: theme.textPrimary }]}>Filter Date (YYYY-MM-DD)</Text>
          <View style={styles.row}>
            <TextInput
              value={selectedDate}
              onChangeText={setSelectedDate}
              placeholder="YYYY-MM-DD"
              placeholderTextColor={theme.textSecondary}
              style={[
                globalStyles.input,
                {
                  flex: 1,
                  backgroundColor: theme.inputBg,
                  borderColor: theme.border,
                  color: theme.textPrimary,
                  marginBottom: 0,
                },
              ]}
            />
            <TouchableOpacity
              onPress={() => setSelectedDate(todayStr)}
              style={[globalStyles.buttonPrimary, { paddingHorizontal: 16, paddingVertical: 12, marginLeft: 10 }]}
            >
              <Text style={globalStyles.buttonText}>Today</Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Schedule Details */}
        {data?.schedule ? (
          <View style={[globalStyles.card, { backgroundColor: theme.cardBg, borderColor: theme.border, marginBottom: 20 }]}>
            <View style={styles.cardHeader}>
              <Text style={[styles.cardTitle, { color: theme.textPrimary }]}>
                📅 Admin Working Hours
              </Text>
              <View style={styles.badgeWorking}>
                <Text style={styles.badgeText}>WORKING DAY</Text>
              </View>
            </View>

            <View style={[styles.detailRow, { borderBottomColor: theme.border }]}>
              <Text style={[styles.detailLabel, { color: theme.textSecondary }]}>Shift Window:</Text>
              <Text style={[styles.detailValue, { color: theme.textPrimary }]}>
                {data.schedule.startTime} - {data.schedule.endTime}
              </Text>
            </View>

            {data.schedule.breakStart && (
              <View style={[styles.detailRow, { borderBottomColor: theme.border }]}>
                <Text style={[styles.detailLabel, { color: theme.textSecondary }]}>Break Period:</Text>
                <Text style={[styles.detailValue, { color: COLORS.warning }]}>
                  {data.schedule.breakStart} - {data.schedule.breakEnd}
                </Text>
              </View>
            )}

            <View style={[styles.detailRow, { borderBottomColor: 'transparent', marginBottom: 12 }]}>
              <Text style={[styles.detailLabel, { color: theme.textSecondary }]}>Max Meetings Per Slot:</Text>
              <Text style={[styles.detailValue, { color: theme.textPrimary }]}>
                {data.schedule.maxMeetingsPerSlot} visitors
              </Text>
            </View>

            <SlotPicker
              slots={data.slots || []}
              selectedSlot={null}
              onSelectSlot={(time) => {
                navigation.navigate('CreateMeeting', {
                  initialDate: selectedDate,
                  initialTime: time,
                  scheduleId: data.schedule?.id,
                });
              }}
            />
          </View>
        ) : (
          <View style={[globalStyles.card, { backgroundColor: theme.cardBg, borderColor: theme.border, alignItems: 'center', paddingVertical: 32 }]}>
            <Text style={{ fontSize: 40, marginBottom: 12 }}>🏖️</Text>
            <Text style={[styles.cardTitle, { color: theme.textPrimary }]}>
              No Master Admin Schedule Set
            </Text>
            <Text style={[styles.emptySubtitle, { color: theme.textSecondary }]}>
              Master Admin has not defined work hours for {selectedDate}. Contact Admin to initialize work schedule.
            </Text>
          </View>
        )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    fontSize: 12,
    fontWeight: '700',
    marginBottom: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 14,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '800',
  },
  badgeWorking: {
    backgroundColor: COLORS.successBg,
    borderColor: COLORS.success,
    borderWidth: 1,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
  },
  badgeText: {
    color: COLORS.success,
    fontSize: 10,
    fontWeight: '800',
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomWidth: 1,
  },
  detailLabel: {
    fontSize: 12,
  },
  detailValue: {
    fontSize: 12,
    fontWeight: '700',
  },
  emptySubtitle: {
    fontSize: 12,
    textAlign: 'center',
    marginTop: 6,
    lineHeight: 18,
  },
});
